import axiosInstance from './axios';

export const medicalApi = {
    getSurveyStatusOverview: async function(season) {
        try {
            const response = await axiosInstance.get(`/medical/reports?season=${season}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching survey status overview:', error);
            throw error;
        }
    },
}